// src/pages/Moderation/ChannelsViolationsPage/ui/ChannelsViolationsTable/ChannelsViolationsRow.tsx
import React from 'react';
import { Link } from 'react-router-dom';

import { GetFlagsResponse } from 'redux/reducers/moderation/types';
import { base } from 'routes/ModerationRoutes';
import { decodeRestrictionValue } from 'untils/decodeRestrictions';
import { ModerationChannel } from '../model/types';
import { restrictionsCountChannel } from '../model/utils';

type Props = {
  channel: ModerationChannel;
  onClick?: () => void;
  flags: GetFlagsResponse | null;
};

export const ChannelsViolationsRow: React.FC<Props> = ({ flags, channel, onClick }) => {
  const totalCnt = restrictionsCountChannel(channel);

  return (
    <div className="cv-table__row" onClick={onClick} role="button" tabIndex={0}>
      <div className="cv-table__cell">
        <div className="cv-table__main">{channel.title || 'Unknown channel'}</div>
        <div className="cv-table__sub">{channel.category || '—'}</div>
      </div>

      <div className="cv-table__cell">
        <div className="cv-table__main">{channel.link || '—'}</div>
      </div>

      <div className="cv-table__cell">
        <div className="cv-table__main">{channel.id}</div>
      </div>

      <div className="cv-table__cell">
        {totalCnt > 0 ? (
          <div className="cv-table__badges">
            {(channel.restrictions ?? []).slice(0, 4).map((r) => (
              <span className="cv-table__badge" key={r.restriction}>
                {flags ? decodeRestrictionValue(r.restriction, flags.data) : null}
              </span>
            ))}
          </div>
        ) : (
          <div className="cv-table__sub">—</div>
        )}
      </div>

      <div className="cv-table__cell">
        <div className="cv-table__main">{channel.created_at || '—'}</div>
      </div>

      <div className="cv-table__cell">
        <Link className="cv-table__open" to={`${base}/channel/violations/${channel.id}`}>
          Open
        </Link>
      </div>
    </div>
  );
};
